import React from 'react';
import { getGlobal } from 'reactn';
import Card from '../card/Card';
import Button from '../button/Button';
import DownloadIconWhite from '../../assets/DownloadIcon.png';
import WaterIcon from '../../assets/WaterIconLg.png';

const WaterFacts = ({ ...rest }) => {
  const { siteDetails } = getGlobal();
  return (
    <Card title="Water Facts" {...rest}>
      <p>
        The Monroe County Water Authority holds itself accountable to the highest
        standards. See how we measure up.
      </p>
      <div className="flex justify-start align-center h-14 mb-0">
        <img src={WaterIcon} alt="water-icon" className="mr-5 my-auto" />
        <h3 className="text-blue-dark font-extrabold my-2 text-3xl">
          20 Billion
        </h3>
      </div>
      <p>Gallons of water each year</p>
      <div className="flex justify-start align-center h-14 mb-0">
        <img src={WaterIcon} alt="water-icon" className="mr-5 my-auto" />
        <h3 className="text-blue-dark font-extrabold my-2 text-3xl">
          $19 Million
        </h3>
      </div>
      <p>Infrastructure improvements</p>
      <div className="flex justify-start align-center h-14 mb-0">
        <img src={WaterIcon} alt="water-icon" className="mr-5 my-auto" />
        <h3 className="text-blue-dark font-extrabold my-2 text-3xl">
          25% Lower
        </h3>
      </div>
      <p>Water rates than the average northeast suppliers</p>

      <Button
        href={siteDetails.mcwa_water_quality_report_url}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full"
        iconUrl={DownloadIconWhite}
      >
        Water Quality Report
      </Button>
    </Card>
  );
};

export default WaterFacts;
